import React from 'react';
import { Image, Col } from 'react-bootstrap';

import './logoUsageComponent.scss'

class LogoUsageComponent extends React.Component {
    render() {
        return <div className="logo-usage-component">
            <div className="section">
                <p>The Life Fitness name has been on products since 1987 and maintains strong recognition around the world. Use the following basic rules to ensure consistent use of the Life Fitness identity.</p>
            </div>

            <div className="row">
                <Col xs={6} md={4} align="center">
                    <Image src={require('../../../../images/life-fitness-logo.png')} />
                </Col>
            </div>

            <div className="section">
                <h3>COLOR USAGE</h3>
                <p>The primary and preferred use of the Life Fitness logo should be in Life Fitness red (#d01f2e). The black logo is also acceptable when necessary.</p>
                <div className="row">
                    <Col xs={6} md={4} align="center">
                        <Image src={require('../../../../images/primary-secondary-logos.png')} />
                    </Col>
                </div>
            </div>

            <div className="section">
                <p>When using the Life Fitness logo on a dark background, the logo must be reversed and used in white.</p>
                <div className="row">
                    <Col md={12} align="center">
                        <Image src={require('../../../../images/reversed-logo.png')} />
                    </Col>
                </div>
            </div>

            <br />
            <div className="section">
                <h3>LOGO COLORS</h3>
                <p>The only colors allowed for the Life Fitness identity are shown below.</p>
                <div className="row">
                    <Col xs={6} md={4} align="center">
                        <Image src={require('../../../../images/branding-colors.png')} />
                    </Col>
                </div>
            </div>

            <br />
            <div className="section">
                <h3>MINIMUM CLEAR SPACE</h3>
                <p>Maintain a minimum clear space around the identity equal to the height of the "s".</p>
                <div className="row">
                    <Col xs={6} md={4} align="center">
                        <Image src={require('../../../../images/minimum-clear-space.png')} />
                    </Col>
                </div>
            </div>

            <br />
            <div className="section">
                <h3>MINIMUM SIZE</h3>
                <p>The minimum size for logo use is 200px wide. The logo must scale proportionately. Please do not recreate, modify or alter the log in any way.</p>
                <div className="row">
                    <Col md={12} align="center">
                        <Image src={require('../../../../images/minimum-size.png')} />
                    </Col>
                </div>
            </div>

            <br />
            <div className="section">
                <h3>LOGO DONTS</h3>
                <p>Variations of the Life Fitness identity are not permitted. Alterations can confuse the brand identity and hamper legal protection. Below are examples of improper use:</p>
                <div className="row">
                    <Col xs={6} md={4} align="center">
                        <Image src={require('../../../../images/logo-donts-1.png')} />
                        <p>Do not reconstruct, respace or manipulate the logo in any way.</p>
                    </Col>
                    <Col xs={6} md={4} align="center">
                        <Image src={require('../../../../images/logo-donts-2.png')} />
                        <p>Do not reproduce the logo on a background that dose not offer adequate contrast and readability.</p>
                    </Col>
                    <Col xs={6} md={4} align="center">
                        <Image src={require('../../../../images/logo-donts-3.png')} />
                        <p>Do not reproduce the logo on textured or visually distracting backgrounds.</p>
                    </Col>
                </div>
                <div className="row">
                    <Col xs={6} md={4} align="center">
                        <Image src={require('../../../../images/logo-donts-4.png')} />
                        <p>Do not add a rule, drop shadow, or any other graphic treatment to the logo.</p>
                    </Col>
                    <Col xs={6} md={4} align="center">
                        <Image src={require('../../../../images/logo-donts-5.png')} />
                        <p>Do not apply a screen or use any other color treatment.</p>
                    </Col>
                    <Col xs={6} md={4} align="center">
                        <Image src={require('../../../../images/logo-donts-6.png')} />
                        <p>Do not scan the identity or use a poor resolution version.</p>
                    </Col>
                </div>
            </div>
        </div>
    }
}

export default LogoUsageComponent



// WEBPACK FOOTER //
// ./src/components/marketingGuidelines/marketingComponents/LogoUsage/LogoUsageComponent.js